module.exports = __webpack_public_path__ + "img/montage_header_small.e96d05e8.webp";